import { Controller } from "@hotwired/stimulus";

const STORAGE_KEY = "siteAlertDismissed";
const DISMISSED_ATTRIBUTE = "data-site-alert-dismissed";
const FOCUSABLE =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

// checkVisibility() is missing before Safari 17.4
const isVisible = (element) =>
  element.checkVisibility?.() ?? element.getClientRects().length > 0;

// Dismissable sitewide alert. The dismissal is stored per alert id, so a new
// alert shows again. A script in the layout <head> applies the stored
// dismissal before render; this controller keeps it in sync.
//
// Connects to data-controller="site-alert"
export default class extends Controller {
  static values = { id: String };

  connect() {
    this.toggleDismissed(this.storedId === this.idValue);
  }

  dismiss() {
    const nextFocusable = this.nextFocusable();

    try {
      localStorage.setItem(STORAGE_KEY, this.idValue);
    } catch {
      // Storage unavailable: still hide for this page view
    }

    this.toggleDismissed(true);
    nextFocusable?.focus();
  }

  get storedId() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch {
      return null;
    }
  }

  toggleDismissed(dismissed) {
    document.documentElement.toggleAttribute(DISMISSED_ATTRIBUTE, dismissed);
  }

  // Keep keyboard users in place once the alert disappears
  nextFocusable() {
    return [...document.querySelectorAll(FOCUSABLE)].find(
      (element) =>
        !this.element.contains(element) &&
        this.element.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING &&
        isVisible(element),
    );
  }
}
